var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseButton',{attrs:{"tag":"button","modifier":"medium"},on:{"click":_vm.refineAndScroll}},[_vm._v("\n    View more\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }